import React, { Component } from 'react'
import downloadService from '../../common/downloadlog-service.js'
import config from '../../resource/appConfig.js'
import Modal from '../../components/modals/downloadLogModal'

const S = config.reqStatuses.submit,
    VF = config.reqStatuses.validationFailed,
    VSW = config.reqStatuses.validationSuccesswithErrors,
    FwF = config.reqStatuses.fulfilledWithFailures,
    FF = config.reqStatuses.fulfilled,
    TO = config.reqStatuses.timedOut


class downloadLink extends Component {
    constructor(props) {
        super(props)
        this.clickAction = this.clickAction.bind(this)
    }

    clickAction() {
        const requestId = this.props.PassDataItems.REQUEST_ID
        const cognitoId = this.props.PassDataItems.COGNITO_ID


        let apiAuthHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CB-Catapult-Authentication-Token': JSON.parse(sessionStorage.authSession).authnToken,
            'X-CB-Catapult-Authorization-Token': JSON.parse(sessionStorage.authSession).authzToken
        }
        console.log("FileName in download link", this.props.PassDataItems.FILE_NAME)
        this.download = new downloadService()
        this.download.handleclick(requestId, cognitoId, apiAuthHeaders)
    }

    render() {
        const triggerId = `downloadLogModalTrigger${this.props.index ?? this.props.PassDataItems.REQUEST_ID}`
        const status = this.props.PassDataItems.REQ_STATUS
        let uploadType = this.props.PassDataItems.UPLOAD_TYPE
        let LogFileStatus = this.props.PassDataItems.LOG_FILE_STATUS
        let errorCount = this.props.PassDataItems.ERROR_COUNT
        return (
            <div>
                <li className={(status === FF || status === FwF || status === S || status === TO || uploadType === "4" || ((status === VF || status === VSW) && (errorCount && errorCount > config.erroneousRowsCountLimit))) ? "btn btn-sm btn-secondary borderdownload" : null}>
                    {(LogFileStatus && (LogFileStatus === "GENERATED")) ?
                        <strong>
                            <p>
                                <button type="button" className="linkButton"
                                        data-cbtrack-download={this.props.PassDataItems.FILE_NAME} tabIndex="0"
                                        id="downloadloglink" onClick={this.clickAction}>Download Request Log File
                                </button>
                            </p>
                        </strong> :
                        <strong>
                            <p>
                                <button type="button" className="linkButton" tabIndex="0" id={triggerId}
                                        aria-haspopup="dialog">Download Request Log File
                                </button>
                            </p>
                        </strong>}
                </li>
                <Modal triggerId={triggerId} apiAuthHeaders={this.props.apiAuthHeaders}
                       PassDataItems={this.props.PassDataItems} />
            </div>
        )
    }

}

export default downloadLink
